import { InjectionToken } from '@angular/core';

export const BX_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('BX_MOCK_API_DEFAULT_DELAY');
